import { useState, useCallback } from 'react'
import { usePayload } from './hooks/usePayload'
import { LoadingScreen } from './components/LoadingScreen'
import { ErrorScreen } from './components/ErrorScreen'
import { Dashboard } from './components/Dashboard'

// Lets a "Copiar Link da Edição" share URL (?edicion=2026-06) land straight
// on that edition instead of always resolving to the default/most recent one.
function readInitialPeriodFromQuery(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined
  }

  return new URLSearchParams(window.location.search).get('edicion') ?? undefined
}

export function App() {
  const [period, setPeriod] = useState<string | undefined>(readInitialPeriodFromQuery)
  const state = usePayload(period)

  const handleRetry = useCallback(() => {
    setPeriod(p => p)
  }, [])

  return (
    <>
      {state.status === 'loading' && <LoadingScreen />}

      {state.status === 'error' && (
        <ErrorScreen message={state.message} onRetry={handleRetry} />
      )}

      {state.status === 'success' && (
        <Dashboard payload={state.data} onEditionChange={setPeriod} />
      )}
    </>
  )
}
